import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Button from 'components/Form/Button';
import App from 'modules/App';
const LinkButton = ({ to, labelMessage })=>/*#__PURE__*/ _jsx(Button, {
        type: "link",
        to: to,
        labelMessage: labelMessage || App.messages.buttons.config,
        className: "btn--outline"
    });
export default LinkButton;
